import type { NAccessRights } from '@app/types';

// Названия сервисов/сущностей
export const RIGHTS_CHAINS = 'Chains';
export const RIGHTS_BRANCHES = 'Branches';
export const RIGHTS_USERS = 'Users';
export const RIGHTS_CLIENTS = 'Clients';
export const RIGHTS_LEGAL_ENTITIES = 'LegalEntities';
export const RIGHTS_ANALYTICS = 'Analytics';
export const RIGHTS_SALARIES = 'Salaries';
export const RIGHTS_RECORDS = 'Records';
export const RIGHTS_SALES_REGISTER = 'SalesRegister';
export const RIGHTS_PAYMENT_ACCOUNTS = 'PaymentAccounts';
export const RIGHTS_WORK_SCHEDULES = 'WorkSchedules';
export const RIGHTS_CLIENT_SERVICES = 'ClientServices';

export const RIGHTS_POSITIONS = 'Positions';
export const RIGHTS_SALE_PLANS = 'SalePlans';
export const RIGHTS_DATA_MIGRATIONS = 'DataMigrations';
export const RIGHTS_INTEGRATIONS = 'Integrations';
export const RIGHTS_ACCESS_RIGHTS_TEMPLATES = 'AccessRights';
export const RIGHTS_HISTORY = 'History';
export const RIGHTS_LEADS = 'Leads';
export const RIGHTS_SALES_FUNNELS = 'SalesFunnels';
export const RIGHTS_CRM_TASKS = 'CrmTasks';
export const RIGHTS_ORGANIZATIONS = 'Organizations';
export const RIGHTS_MODULES = 'Modules';
export const RIGHTS_SENDOUTS = 'Sendouts';
export const RIGHTS_AI = 'AiOperator';
export const RIGHTS_MESSAGE_TEMPLATES = 'MessageTemplates';
export const RIGHTS_WAREHOUSE = 'Warehouse';
export const RIGHTS_PRODUCTS = 'Products';
export const RIGHTS_MEDICAL_DOCUMENTS = 'MedicalDocuments';

// Ключи для прав модулей
export const LEADS_MODULE_KEY = 1;
export const INTEGRATIONS_MODULE_KEY = 2;
export const TASKS_MODULE_KEY = 3;
export const RECORDS_MODULE_KEY = 4;
export const SALES_FUNNELS_MODULE_KEY = 5;
export const WHATS_APP_INTEGRATIONS_MODULE_KEY = 6;
export const SENDOUTS_MODULE_KEY = 7;
export const AI_MODULE_KEY = 8;
export const LOYALTY_MODULE_KEY = 10;

// Соответствие модулей и прав доступа
export const RIGHTS_AND_MODULE_ACCORDANCE: Partial<{
  [key in NAccessRights.EntityId]: number;
}> = {
  [RIGHTS_LEADS]: LEADS_MODULE_KEY,
  [RIGHTS_INTEGRATIONS]: INTEGRATIONS_MODULE_KEY,
  [RIGHTS_CRM_TASKS]: TASKS_MODULE_KEY,
  [RIGHTS_RECORDS]: RECORDS_MODULE_KEY,
  [RIGHTS_SALES_FUNNELS]: SALES_FUNNELS_MODULE_KEY,
  [RIGHTS_SENDOUTS]: SENDOUTS_MODULE_KEY,
};

// Ключи для типовых прав
export const RIGHTS_IS_ON = 'IsOn';
export const RIGHTS_IS_CREATE = 'IsCreate';
export const RIGHTS_IS_EDIT = 'IsEdit';
export const RIGHTS_IS_DELETE = 'IsDelete';
export const RIGHTS_IS_EXPORT = 'IsExport';
export const RIGHTS_IS_IMPORT = 'IsImport';

// Ключи для специальных прав
export const RIGHTS_IS_EDIT_TAGS = 'IsEditTags';
export const RIGHTS_IS_CREATE_SERVICES = 'IsCreateServices';
export const RIGHTS_IS_EDIT_SERVICES = 'IsEditServices';
export const RIGHTS_IS_WORK_SCHEDULE_VIEW = 'IsWorkScheduleView';
export const RIGHTS_IS_WORK_SCHEDULE_EDIT = 'IsWorkScheduleEdit';
export const RIGHTS_IS_WORK_SCHEDULE_EDIT_IN_PAST = 'IsWorkScheduleEditInPast';
export const RIGHTS_IS_ACCESS_RIGHTS_VIEW = 'IsAccessRightsView';
export const RIGHTS_IS_ACCESS_RIGHTS_EDIT = 'IsAccessRightsEdit';
export const RIGHTS_IS_ACTION_HISTORY_VIEW = 'IsActionHistoryView';
export const RIGHTS_IS_DELETE_FROM_JOURNAL = 'IsDeleteFromJournal';
export const RIGHTS_IS_EDIT_PAST = 'IsEditPast';
export const RIGHTS_IS_DELETE_PAST = 'IsDeletePast';
export const RIGHTS_IS_CHANGE_OWNER = 'IsChangeOwner';
export const RIGHTS_IS_OWNER_CHANGE = 'IsOwnerChange';
export const RIGHTS_IS_CHANGE_BRANCHES = 'IsChangeBranches';
export const RIGHTS_IS_USER = 'IsUsers';
export const RIGHTS_IS_EMPLOYEES = 'IsEmployees';
export const RIGHTS_IS_JOURNAL = 'IsJournal';
export const RIGHTS_IS_REGISTER = 'IsRegister';
export const RIGHTS_IS_EMPLOYEES_REGISTER = 'IsEmployees';
export const RIGHTS_IS_USERS_REGISTER = 'IsUsers';
export const RIGHTS_IS_SHOW_CONTACTS = 'IsShowContacts';
export const RIGHTS_IS_VIEW_COMMUNICATION = 'IsViewCommunication';
export const RIGHTS_IS_CLIENT_SERVICES = 'IsClientServices';
export const RIGHTS_IS_SERVICE_CATEGORIES = 'IsServiceCategories';
export const RIGHTS_IS_CATEGORY_CREATE = 'IsCategoryCreate';
export const RIGHTS_IS_CATEGORY_EDIT = 'IsCategoryEdit';
export const RIGHTS_IS_CATEGORY_DELETE = 'IsCategoryDelete';
export const RIGHTS_IS_ATTACH = 'IsAttach';
export const RIGHTS_IS_CREATE_EXPENSE = 'IsCreateExpense';
export const RIGHTS_IS_CREATE_COLLECTION = 'IsCreateCollection';
export const RIGHTS_IS_TOPPING_UP_CASH = 'IsToppingUpCash';
export const RIGHTS_IS_DELETE_SALE = 'IsDeleteSale';
export const RIGHTS_IS_DELETE_EXPENSE = 'IsDeleteExpense';
export const RIGHTS_IS_DELETE_COLLECTION = 'IsDeleteCollection';
export const RIGHTS_IS_CREATE_TEMPLATES = 'IsCreateTemplates';
export const RIGHTS_IS_DELETE_TEMPLATES = 'IsDeleteTemplates';
export const RIGHTS_IS_EDITING_RIGHTS_WITHIN_OPEN_RIGHTS =
  'EditingRightsWithinOpenRights';
export const RIGHTS_IS_STATUSES = 'IsStatuses';
export const RIGHTS_IS_COMMUNICATE = 'IsCommunicate';
export const RIGHTS_IS_TOP_CLIENT_BALANCE = 'IsTopClientBalance';
export const RIGHTS_IS_VIEW_ALL_RECORDS = 'IsViewAllRecords';
export const RIGHTS_IS_PAY_RECORD = 'IsPayRecord';
export const RIGHTS_IS_FINANCIAL_STATISTICS = 'IsFinancialStatistics';
export const RIGHTS_IS_TAGS_CHANGE = 'IsTagsChange';
export const RIGHTS_IS_VIEW_ALL = 'IsViewAll';
export const RIGHTS_IS_ALLOW_SPAM = 'IsAllowSpam';
export const RIGHTS_IS_TAKE = 'IsTake';
export const RIGHTS_IS_SALE_FUNNEL_CHANGE = 'IsSaleFunnelChange';
export const RIGHTS_IS_EDIT_ALL = 'IsEditAll';
export const RIGHTS_IS_CHANGE_STATUS = 'IsChangeStatus';
export const RIGHTS_IS_ASSIGN = 'IsAssign';
export const RIGHTS_IS_FUNNEL_CREATE = 'IsFunnelCreate';
export const RIGHTS_IS_FUNNEL_EDIT = 'IsFunnelEdit';
export const RIGHTS_IS_FUNNEL_DELETE = 'IsFunnelDelete';
export const RIGHTS_IS_STAGE_CREATE = 'IsStageCreate';
export const RIGHTS_IS_STAGE_EDIT = 'IsStageEdit';
export const RIGHTS_IS_STAGE_DELETE = 'IsStageDelete';
export const RIGHTS_IS_CONTROL = 'IsControl';
export const RIGHTS_IS_VIEW_RECEIVERS = 'IsViewReceivers';
export const RIGHTS_SECRET_LOGIN_TO_ORGANIZATION_ACCOUNT =
  'SecretLoginToOrganizationAccount';
export const RIGHTS_IS_RETURN_MONEY = 'IsReturnMoney';
export const RIGHTS_IS_VIEW_REMINDERS = 'IsViewReminders';
export const RIGHTS_IS_EDIT_REMINDERS = 'IsEditReminders';
export const FINANCIAL_INCOMES_REPORT = 'FinancialIncomesReport';
export const FINANCIAL_FACT_IMPL_REPORT = 'FinancialFactImplReport';
export const FINANCIAL_EXPENSE_BY_ARTICLES_REPORT =
  'FinancialExpenseByArticlesReport';
export const FINANCIAL_PNL_REPORT = 'FinancialPnlReport';
export const FINANCIAL_DETAILS_OF_EXPENSES_REPORT =
  'FinancialDetailsOfExpensesReport';
export const FINANCIAL_BRANCH_INDICATOR_REPORT =
  'FinancialBranchIndicatorsReport';
export const EDIT_BEFORE_CONFIRM = 'EditBeforeConfirm';
export const EDIT_AFTER_CONFIRM = 'EditAfterConfirm';
export const CONFIRM_SALARY = 'Confirm';

// Остальные данные
export const ACCESS_RIGHTS_PROP = 'AccessRights';
export const PROD_BY_HELP_DATABASE = 'Crm-000-002';

// Массивы для страницы назначения прав
export const RIGHTS_LIST_CHAINS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание сетей',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование сетей',
  },
];

export const RIGHTS_LIST_BRANCHES: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание филиалов',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование филиалов',
  },
];

export const RIGHTS_LIST_CLIENTS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_SHOW_CONTACTS,
    label: 'Просмотр контактных данных клиентов',
  },
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание клиентов',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование клиентов',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление клиентов',
  },
  {
    specificRightId: RIGHTS_IS_EXPORT,
    label: 'Выгрузка клиентов в файл Excel',
  },
  {
    specificRightId: RIGHTS_IS_COMMUNICATE,
    label: 'Переписка с клиентами',
  },
  {
    specificRightId: RIGHTS_IS_VIEW_COMMUNICATION,
    label: 'Просмотр переписки с клиентом',
  },
  {
    specificRightId: RIGHTS_IS_TAGS_CHANGE,
    label: 'Редактирование тегов',
  },
];

export const RIGHTS_LIST_USERS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_EMPLOYEES,
    label: 'Реестр исполнителей',
  },
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание пользователей / исполнителей',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование пользователей / исполнителей',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление пользователей / исполнителей',
  },
  {
    specificRightId: RIGHTS_IS_EXPORT,
    label: 'Выгрузка исполнителей в файл Excel',
  },
  {
    specificRightId: RIGHTS_IS_IMPORT,
    label: 'Создание исполнителей через файл Excel',
  },

  // На 26.12.2024 в Сваггере не было этих специальных прав, однако сервер возвращал их
  // для загрузки списка прав, а также принимал их на вход при сохранении выбранных прав пользователем
  {
    specificRightId: RIGHTS_IS_USER,
    label: 'Реестр пользователей',
  },
  {
    specificRightId: RIGHTS_IS_CHANGE_OWNER,
    label: 'Наделение пользователя наивысшими правами (владелец)',
  },
  {
    specificRightId: RIGHTS_IS_CHANGE_BRANCHES,
    label: 'Редактирование филиалов пользователя / исполнителя',
  },
];

export const RIGHTS_LIST_RECORDS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_JOURNAL,
    label: 'Журнал записей',
  },
  {
    specificRightId: RIGHTS_IS_REGISTER,
    label: 'Реестр записей',
  },
  {
    specificRightId: RIGHTS_IS_STATUSES,
    label: 'Смена статусов без ограничений',
  },
  {
    specificRightId: RIGHTS_IS_EXPORT,
    label: 'Выгрузка записей в файл Excel',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление записей',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование записей',
  },
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание записей',
  },
  {
    specificRightId: RIGHTS_IS_VIEW_ALL_RECORDS,
    label: 'Видимость всех записей',
  },
  {
    specificRightId: RIGHTS_IS_PAY_RECORD,
    label: 'Оплата записи',
  },
  {
    specificRightId: RIGHTS_IS_FINANCIAL_STATISTICS,
    label: 'Видимость финансовой статистики',
  },
  {
    specificRightId: RIGHTS_IS_VIEW_REMINDERS,
    label: 'Настройка уведомлений клиентам',
  },
];

export const RIGHTS_LIST_WORK_SCHEDULES: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание графиков работы',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование графиков работы',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление графиков работы',
  },
  {
    specificRightId: RIGHTS_IS_EDIT_PAST,
    label: 'Редактирование графиков работы в прошлом',
  },
  {
    specificRightId: RIGHTS_IS_DELETE_PAST,
    label: 'Удаление графиков работы в прошлом',
  },
];

export const RIGHTS_LIST_PAYMENT_ACCOUNTS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание касс',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование касс',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление касс',
  },
];

export const RIGHTS_LIST_CLIENT_SERVICES: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CLIENT_SERVICES,
    label: 'Реестр услуг',
  },
  {
    specificRightId: RIGHTS_IS_SERVICE_CATEGORIES,
    label: 'Реестр категорий услуг',
  },
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание услуг',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование услуг',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление услуг',
  },
  {
    specificRightId: RIGHTS_IS_EXPORT,
    label: 'Выгрузка услуг в файл Excel',
  },
  {
    specificRightId: RIGHTS_IS_IMPORT,
    label: 'Редактирование услуг через файл Excel',
  },
  {
    specificRightId: RIGHTS_IS_CATEGORY_CREATE,
    label: 'Создание категорий услуг',
  },
  {
    specificRightId: RIGHTS_IS_CATEGORY_EDIT,
    label: 'Редактирование категорий услуг',
  },
  {
    specificRightId: RIGHTS_IS_CATEGORY_DELETE,
    label: 'Удаление категорий услуг',
  },
  {
    specificRightId: RIGHTS_IS_ATTACH,
    label: 'Назначение услуг исполнителям',
  },
];

export const RIGHTS_LIST_POSITIONS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание должностей',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование должностей',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление должностей',
  },
];

export const RIGHTS_LIST_LEGAL_ENTITIES: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание юридических лиц',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование юридических лиц',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление юридических лиц',
  },
];

export const RIGHTS_LIST_SALE_PLANS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание и редактирование планов продаж',
  },
  {
    specificRightId: RIGHTS_IS_EXPORT,
    label: 'Выгрузка плана продаж в файл Excel',
  },
];

export const RIGHTS_LIST_MIGRATION_Y_CLIENTS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание миграций данных',
  },
];

export const RIGHTS_LIST_INTEGRATIONS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание интеграций',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование интеграций',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление интеграций',
  },
];

export const RIGHTS_LIST_ACCESS_RIGHTS_TEMPLATES: NAccessRights.RightsListItem[] =
  [
    {
      specificRightId: RIGHTS_IS_CREATE_TEMPLATES,
      label: 'Создание шаблонов прав доступа',
    },
    {
      specificRightId: RIGHTS_IS_DELETE_TEMPLATES,
      label: 'Удаление шаблонов прав доступа',
    },
    {
      specificRightId: RIGHTS_IS_EDITING_RIGHTS_WITHIN_OPEN_RIGHTS,
      label:
        '⁠Возможность редактировать права только в рамках открытых пользователю прав',
    },
  ];

export const RIGHTS_LIST_FINANCIAL_OPERATIONS: NAccessRights.RightsListItem[] =
  [
    {
      specificRightId: RIGHTS_IS_CREATE_EXPENSE,
      label: 'Создание расходов',
    },
    {
      specificRightId: RIGHTS_IS_CREATE_COLLECTION,
      label: 'Создание инкассаций',
    },
    {
      specificRightId: RIGHTS_IS_TOPPING_UP_CASH,
      label: 'Пополнение касс',
    },
    {
      specificRightId: RIGHTS_IS_DELETE_SALE,
      label: 'Удаление платежей',
    },
    {
      specificRightId: RIGHTS_IS_DELETE_EXPENSE,
      label: 'Удаление расходов',
    },
    {
      specificRightId: RIGHTS_IS_DELETE_COLLECTION,
      label: 'Удаление инкассаций',
    },
    {
      specificRightId: RIGHTS_IS_TOP_CLIENT_BALANCE,
      label: 'Пополнение баланса клиента',
    },
    {
      specificRightId: RIGHTS_IS_RETURN_MONEY,
      label: 'Возврат денег с баланса клиента',
    },
    {
      specificRightId: RIGHTS_IS_EXPORT,
      label: 'Выгрузка финансов в файл Excel',
    },
  ];

export const RIGHTS_LIST_LEADS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление лидов',
  },
  {
    specificRightId: RIGHTS_IS_OWNER_CHANGE,
    label: 'Смена ответственного',
  },
  {
    specificRightId: RIGHTS_IS_VIEW_ALL,
    label: 'Видимость лидов других ответственных',
  },
  {
    specificRightId: RIGHTS_IS_ALLOW_SPAM,
    label: 'Отправка лидов в спам',
  },
  {
    specificRightId: RIGHTS_IS_TAKE,
    label: 'Принятие диалога',
  },
  {
    specificRightId: RIGHTS_IS_SALE_FUNNEL_CHANGE,
    label: 'Смена воронок продаж на чужих лидах',
  },
  {
    specificRightId: RIGHTS_IS_COMMUNICATE,
    label: 'Отправка сообщений в чужих лидах',
  },
];

export const RIGHTS_LIST_TASKS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_VIEW_ALL,
    label: 'Просмотр задач других ответственных',
  },
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание задачи',
  },
  {
    specificRightId: RIGHTS_IS_EDIT,
    label: 'Редактирование задачи',
  },
  {
    specificRightId: RIGHTS_IS_EDIT_ALL,
    label: 'Редактирование задач других ответственных',
  },
  {
    specificRightId: RIGHTS_IS_CHANGE_STATUS,
    label: 'Выполнение и возврат задач в работу ',
  },
  {
    specificRightId: RIGHTS_IS_DELETE,
    label: 'Удаление задач',
  },
];

export const RIGHTS_LIST_SENDOUTS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_IS_CREATE,
    label: 'Создание рассылок (и автоматический запуск после их создания)',
  },
  {
    specificRightId: RIGHTS_IS_CONTROL,
    label: 'Запуск и остановка рассылок',
  },
  {
    specificRightId: RIGHTS_IS_VIEW_RECEIVERS,
    label: 'Просмотр получателей рассылок',
  },
];

export const RIGHTS_LIST_ORGANIZATIONS: NAccessRights.RightsListItem[] = [
  {
    specificRightId: RIGHTS_SECRET_LOGIN_TO_ORGANIZATION_ACCOUNT,
    label: 'Секретный вход в аккаунт организации',
  },
];
